module.exports = __webpack_public_path__ + "static/media/form404.bf9b78e1.png";